module.exports = __webpack_public_path__ + "media/country_flags/id-56cecf10.png";